import React from 'react';
import clsx from 'clsx';
import styles from './FormRow.module.scss';

/**
 * FormRow
 *
 * Layout component for arranging multiple form controls (Field components)
 * horizontally with consistent spacing.
 *
 * Props:
 * - children: React nodes (Fields or other form controls)
 * - gap: spacing token or CSS value (optional, default uses design token)
 * - className: optional additional class
 */
const FormRow = ({ children, gap = 'var(--space-4)', className }) => {
  return (
    <div
      className={clsx(styles.row, className)}
      style={{ gap }}
    >
      {children}
    </div>
  );
};

export default FormRow;
